import React, { useMemo } from "react";
import { PageBase } from "../components/PageBase";
import { TextPage } from "../components/TextPage";
import callback from "../utils/prototypeDefinitions/Date.prototype.addDays";

callback();

const generateTasks = () => {
    const startDay = new Date();

    // startDay.setMonth(0);
    // startDay.setDate(1);

    const tasks = [];

    for (
        let day = startDay;
        day < startDay.addDays(385);
        day = day.addDays(1)
    ) {
        if (day.getDate() === 1) {
            tasks.push(`''''''''''\n${day.getMonthName()}\n`)
        }

        tasks.push(
            `🔸 ${day.getWeekDayName()} ${day.getDate()}.${
                day.getMonth() + 1
            }.${day.getFullYear()}`,
        );

        if (day.getDay() === 0) {
            tasks.push(`🔶 WEEK ${day.getWeekNumber() - 1}`);
        }
    }

    return tasks.join("\n");
};

export const GoogleTaskTemplaterGenerator = () => {
    const tasks = useMemo(generateTasks);

    return (
        <TextPage heading="Google tasks generator" mdString={tasks}>
        </TextPage>
    );
};
